// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ion-header ion-toolbar {
  --background: var(--bg-app);
  background: var(--bg-app);
  --color: var(--text-primary-token);
  color: var(--text-primary-token);
}
:host ion-content {
  --background: var(--bg-app);
}

.country-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.country-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  border-radius: 16px;
  background: var(--surface-card);
  font-size: 15px;
  color: var(--text-primary-token);
  transition: background 0.15s ease;
}

.country-row.selected {
  background: color-mix(in srgb, var(--brand) 8%, var(--surface-card));
  border: 1.5px solid var(--brand);
  font-weight: 600;
  color: var(--brand);
}`, "",{"version":3,"sources":["webpack://./src/app/components/country-picker-modal/country-picker-modal.component.scss"],"names":[],"mappings":"AAEI;EACE,2BAAA;EACA,yBAAA;EACA,kCAAA;EACA,gCAAA;AADN;AAIE;EACE,2BAAA;AAFJ;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,+BAAA;EACA,eAAA;EACA,gCAAA;EACA,iCAAA;AAHF;;AAMA;EACE,oEAAA;EACA,gCAAA;EACA,gBAAA;EACA,mBAAA;AAHF","sourcesContent":[":host {\n  ion-header {\n    ion-toolbar {\n      --background: var(--bg-app);\n      background: var(--bg-app);\n      --color: var(--text-primary-token);\n      color: var(--text-primary-token);\n    }\n  }\n  ion-content {\n    --background: var(--bg-app);\n  }\n}\n\n.country-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.country-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 18px;\n  border-radius: 16px;\n  background: var(--surface-card);\n  font-size: 15px;\n  color: var(--text-primary-token);\n  transition: background 0.15s ease;\n}\n\n.country-row.selected {\n  background: color-mix(in srgb, var(--brand) 8%, var(--surface-card));\n  border: 1.5px solid var(--brand);\n  font-weight: 600;\n  color: var(--brand);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
